var _g;
var _excluded = ["svgRef"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var SvgRandomIcon = function SvgRandomIcon(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 33.818,
    height: 29.267,
    viewBox: "0 0 33.818 29.267",
    ref: svgRef
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    transform: "translate(0 0)"
  }, /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.999, -0.035, 0.035, 0.999, 9.103, 4.247)",
    fill: "none",
    stroke: "#5a6798",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22.896,
    height: 22.896,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("g", {
    transform: "matrix(0.966, -0.259, 0.259, 0.966, 0, 6.185)",
    fill: "#fff",
    stroke: "#5a6798",
    strokeWidth: 1
  }, /*#__PURE__*/React.createElement("rect", {
    width: 23.896,
    height: 23.896,
    rx: 2,
    stroke: "none"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 0.5,
    y: 0.5,
    width: 22.896,
    height: 22.896,
    rx: 1.5,
    fill: "none"
  })), /*#__PURE__*/React.createElement("circle", {
    cx: 2.276,
    cy: 2.276,
    r: 2.276,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 11.199, 23.8)",
    fill: "#5a6798"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.276,
    cy: 2.276,
    r: 2.276,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 18.893, 21.738)",
    fill: "#5a6798"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.276,
    cy: 2.276,
    r: 2.276,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 9.727, 18.304)",
    fill: "#5a6798"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.276,
    cy: 2.276,
    r: 2.276,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 17.421, 16.242)",
    fill: "#5a6798"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.276,
    cy: 2.276,
    r: 2.276,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 8.254, 12.808)",
    fill: "#5a6798"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 2.276,
    cy: 2.276,
    r: 2.276,
    transform: "matrix(-0.259, -0.966, 0.966, -0.259, 15.948, 10.747)",
    fill: "#5a6798"
  }))));
};
var ForwardRef = /*#__PURE__*/React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgRandomIcon, _extends({
    svgRef: ref
  }, props));
});
export default "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIzMy44MTgiIGhlaWdodD0iMjkuMjY3IiB2aWV3Qm94PSIwIDAgMzMuODE4IDI5LjI2NyI+CiAgPGcgdHJhbnNmb3JtPSJ0cmFuc2xhdGUoMCAwKSI+CiAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgwLjk5OSwgLTAuMDM1LCAwLjAzNSwgMC45OTksIDkuMTAzLCA0LjI0NykiIGZpbGw9Im5vbmUiIHN0cm9rZT0iIzVhNjc5OCIgc3Ryb2tlLXdpZHRoPSIxIj4KICAgICAgPHJlY3QgeD0iMC41IiB5PSIwLjUiIHdpZHRoPSIyMi44OTYiIGhlaWdodD0iMjIuODk2IiByeD0iMS41IiBmaWxsPSJub25lIi8+CiAgICA8L2c+CiAgICA8ZyB0cmFuc2Zvcm09Im1hdHJpeCgwLjk2NiwgLTAuMjU5LCAwLjI1OSwgMC45NjYsIDAsIDYuMTg1KSIgZmlsbD0iI2ZmZiIgc3Ryb2tlPSIjNWE2Nzk4IiBzdHJva2Utd2lkdGg9IjEiPgogICAgICA8cmVjdCB3aWR0aD0iMjMuODk2IiBoZWlnaHQ9IjIzLjg5NiIgcng9IjIiIHN0cm9rZT0ibm9uZSIvPgogICAgICA8cmVjdCB4PSIwLjUiIHk9IjAuNSIgd2lkdGg9IjIyLjg5NiIgaGVpZ2h0PSIyMi44OTYiIHJ4PSIxLjUiIGZpbGw9Im5vbmUiLz4KICAgIDwvZz4KICAgIDxjaXJjbGUgY3g9IjIuMjc2IiBjeT0iMi4yNzYiIHI9IjIuMjc2IiB0cmFuc2Zvcm09Im1hdHJpeCgtMC4yNTksIC0wLjk2NiwgMC45NjYsIC0wLjI1OSwgMTEuMTk5LCAyMy44KSIgZmlsbD0iIzVhNjc5OCIvPgogICAgPGNpcmNsZSBjeD0iMi4yNzYiIGN5PSIyLjI3NiIgcj0iMi4yNzYiIHRyYW5zZm9ybT0ibWF0cml4KC0wLjI1OSwgLTAuOTY2LCAwLjk2NiwgLTAuMjU5LCAxOC44OTMsIDIxLjczOCkiIGZpbGw9IiM1YTY3OTgiLz4KICAgIDxjaXJjbGUgY3g9IjIuMjc2IiBjeT0iMi4yNzYiIHI9IjIuMjc2IiB0cmFuc2Zvcm09Im1hdHJpeCgtMC4yNTksIC0wLjk2NiwgMC45NjYsIC0wLjI1OSwgOS43MjcsIDE4LjMwNCkiIGZpbGw9IiM1YTY3OTgiLz4KICAgIDxjaXJjbGUgY3g9IjIuMjc2IiBjeT0iMi4yNzYiIHI9IjIuMjc2IiB0cmFuc2Zvcm09Im1hdHJpeCgtMC4yNTksIC0wLjk2NiwgMC45NjYsIC0wLjI1OSwgMTcuNDIxLCAxNi4yNDIpIiBmaWxsPSIjNWE2Nzk4Ii8+CiAgICA8Y2lyY2xlIGN4PSIyLjI3NiIgY3k9IjIuMjc2IiByPSIyLjI3NiIgdHJhbnNmb3JtPSJtYXRyaXgoLTAuMjU5LCAtMC45NjYsIDAuOTY2LCAtMC4yNTksIDguMjU0LCAxMi44MDgpIiBmaWxsPSIjNWE2Nzk4Ii8+CiAgICA8Y2lyY2xlIGN4PSIyLjI3NiIgY3k9IjIuMjc2IiByPSIyLjI3NiIgdHJhbnNmb3JtPSJtYXRyaXgoLTAuMjU5LCAtMC45NjYsIDAuOTY2LCAtMC4yNTksIDE1Ljk0OCwgMTAuNzQ3KSIgZmlsbD0iIzVhNjc5OCIvPgogIDwvZz4KPC9zdmc+Cg==";
export { ForwardRef as ReactComponent };